import { ChatService } from "@/services";
import { CHAT_QUERY_KEYS, UpdateChatParams } from "@/types";
import { toastApiError, toastSuccess } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useUpdateChat = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationKey: [CHAT_QUERY_KEYS.UPDATE_CHAT],
    mutationFn: ({ id, data }: { id: number; data: UpdateChatParams }) =>
      ChatService.updateChat(id, data),
    onSuccess: (data, variables) => {
      toastSuccess(data.message || "更新が成功しました");

      // reset chat room detail cache
      queryClient.invalidateQueries({
        queryKey: [CHAT_QUERY_KEYS.CHAT_BY_ID, variables.id],
      });

      // reset list chat room
      queryClient.invalidateQueries({ queryKey: [CHAT_QUERY_KEYS.ALL_CHATS] });
    },
    onError: toastApiError,
  });

  return {
    updateChat: mutateAsync,
    isUpdatingChat: isPending,
  };
};
